import { CheckCircle2, MapPin, Phone } from "lucide-react";
import { COMPANY, MEDIA } from "../lib/constants";

const VALUES = [
  "God service og en ordentlig tone",
  "Ordentligt arbejde — også i detaljerne",
  "Gennemsigtige priser uden overraskelser",
  "Lokal, stabil og til at få fat på",
];

export default function About() {
  return (
    <section
      id="om"
      data-testid="about-section"
      className="relative bg-white py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Portrait */}
          <div className="lg:col-span-5 relative">
            <div className="relative img-reveal">
              <img
                src={MEDIA.portrait}
                alt="Johnny Lund Jensen — indehaver af JL Service"
                className="w-full h-[480px] md:h-[620px] object-cover"
                loading="lazy"
              />
              <div className="absolute -bottom-px left-0 right-0 h-1 bg-[#0F213A]" />
            </div>
            {/* Signature card */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-[#0F213A] text-white px-6 py-4 shadow-2xl">
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-semibold">
                Indehaver
              </div>
              <div className="text-lg font-black mt-1">
                Johnny Lund Jensen
              </div>
              <div className="text-xs text-white/70 mt-1 flex items-center gap-1.5">
                <MapPin size={12} />
                {COMPANY.city}
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <div className="eyebrow text-[#1E40AF] mb-4">
              <span className="inline-block w-8 h-[2px] bg-[#1E40AF] align-middle mr-3" />
              03 · Mød håndværkeren
            </div>
            <h2
              data-testid="about-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0F213A] leading-[1.05]"
            >
              Mød Johnny.
            </h2>

            <p className="mt-6 text-[#475569] text-lg leading-relaxed">
              Hos <span className="font-bold text-[#0F213A]">JL Service</span>{" "}
              er kunden i centrum. Jeg vægter god service, ordentligt arbejde
              og gennemsigtige priser højt.
            </p>
            <p className="mt-4 text-[#475569] text-base leading-relaxed">
              Kontakt mig for en uforpligtende snak om dit næste projekt — stort
              eller lille. Du får altid et klart svar, en fair pris og et
              håndværk du kan regne med.
            </p>

            {/* Values */}
            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {VALUES.map((v) => (
                <li
                  key={v}
                  className="flex items-start gap-3 text-sm text-[#0F213A] font-medium"
                >
                  <CheckCircle2
                    size={20}
                    className="text-[#1E40AF] shrink-0 mt-0.5"
                    strokeWidth={2}
                  />
                  {v}
                </li>
              ))}
            </ul>

            {/* CTA */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="about-call-btn"
                className="inline-flex items-center justify-center gap-2 bg-[#0F213A] text-white px-7 py-4 text-sm font-bold uppercase tracking-[0.15em] btn-lift"
              >
                <Phone size={16} strokeWidth={2.5} />
                Ring til Johnny
              </a>
              <a
                href="#kontakt"
                data-testid="about-contact-btn"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0F213A] text-[#0F213A] hover:bg-[#0F213A] hover:text-white px-7 py-4 text-sm font-bold uppercase tracking-[0.15em] transition-colors"
              >
                Send en besked
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
